import React, { FC, useEffect, useState } from "react";
import { GridContainer, Hidden, Icon, Link, Typography } from "@insite/mobius/index";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import Button from "@insite/mobius/Button";
import { DataTableCellBaseProps } from "@insite/mobius/DataTable/DataTableCellBase";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import RadioGroup, { RadioGroupProps, RadioGroupStyle } from "@insite/mobius/RadioGroup";
import Radio, { RadioStyle } from "@insite/mobius/Radio";
import { css } from "styled-components";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ADIColors from "@NA/Utils/ADIColors";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import translate from "@insite/client-framework/Translate";
import ADINewAccountModalRecap from "@NA/Components/MyAccountRecapPayment/ADINewAccountModalRecap";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { BankAccount } from "@NA/Services/ADIInvoiceService";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import ADINewAccountAddressModalRecap from "./ADINewAccountAddressModalRecap";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { ResolveThunks, useDispatch, useSelector } from "react-redux";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADINewAccountAddressSuggestionModalRecap from "./ADINewAccountAddressSuggestionModalRecap";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import loadCurrentCountries from "@NA/Store/Data/Countries/Handlers/LoadCurrentCountries";
import styled from "styled-components";
import ValidationSuccessIcon from "@NA/Icons/ValidationSuccessIcon";
import { GridOffset } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import adiGetBankAccountList from "@NA/Handlers/Invoices/ADIGetBankAccountList";


export interface InvoiceHeaderTabsStyles {
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    noDataFound?: InjectableCss;
    newAccount?: InjectableCss;
    bankAccountHeaderContainer?: InjectableCss;
    selectColumn?: InjectableCss;
    accountTypeColumn?: InjectableCss;
    accountDesColumn?: InjectableCss;
    routingNumberColumn?: InjectableCss;
    accountNumberColumn?: InjectableCss;
    bankAccountDataContainer?: InjectableCss;
    radioListGroup?: RadioGroupProps;
    bankAccountContainerForMobile?: InjectableCss;
    selectColumnForMobile?: InjectableCss;
    bankAccountDataContainerForMobile?: InjectableCss;
    newListContainer?: InjectableCss;
    successMessage?: InjectableCss;
    okButton?: InjectableCss;
}

interface customerData {
    email: string,
    customerName: string,
    accountDescription: string,
    accountType: string,
    bankAccountNumber: string,
    routineNumber: string,
    termsAgreed: string | ""
}

export const tableStyles: InvoiceHeaderTabsStyles = {
    centeringWrapper: {
        css: css`
            height: 150px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    noDataFound: {
        css: css`
            margin-top: 36px;
            margin-bottom: 20px;
            font-size: 20px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.3;
            letter-spacing: normal;
            text-align: center;
        color: ${ADIColors.gray4};
            display: block;
        `,
    },
    newAccount: {
        css: css`
          margin-top: 30px;
            margin-bottom: 20px;
            font-size: 20px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.3;
            letter-spacing: normal;
            text-align: center;
        color: ${ADIColors.gray4};
            display: block;
         `
    },
    bankAccountHeaderContainer: {
        css: css`
            display: flex;
            flex-wrap: nowrap;
            background: ${ADIColors.white2};
            font-size: 16px;
            font-weight: bold;
            position: relative;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                    padding: 15px 20px 15px 20px;
                    margin-bottom: 12px;
                    margin-top: 12px;
                `,
                    css`
                    margin-bottom: 12px;
                    margin-top: 12px;
                    padding: 12px 40px;
                    margin-bottom: 12px;
                    margin-top: 12px;
                    padding-right: 0;
                `,
                    css`
                    margin-bottom: 12px;
                    margin-top: 12px;
                    padding: 12px 40px;
                    margin-bottom: 12px;
                    margin-top: 12px;
                    padding-right: 0;
                `,
                ])}
        `,
    },
    bankAccountDataContainer: {
        css: css`
            margin-bottom: 8px;
            padding-right: 0;
            display: flex;
            flex-direction: row;
            width: 100%;
            &:nth-child(even) {
                background-color: ${ADIColors.white}!important;
            }
            &:nth-child(odd) {
                background-color: ${ADIColors.white2};
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`                
                    padding: 15px 20px 15px 20px;
                `,
                    css`
                    padding-left: 40px;
                    padding-top: 15px;
                    padding-bottom: 15px;
                `,
                    css`
                    padding-left: 40px;
                    padding-top: 15px;
                    padding-bottom: 15px;
                `,
                ])}
        `,
    },
    selectColumn: {
        css: css`
            width: 10%;
        `,
    },
    accountTypeColumn: {
        css: css`
            width: 22%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                    width: 20%;
                `,
                    css`
                    width: 22%;
                `,
                    css`
                    width: 22%;
                `,
                ])}
        `,
    },
    accountDesColumn: {
        css: css`
            text-transform: capitalize;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                    width: 25%;
                `,
                    css`
                    width: 22%;                    
                `,
                    css`
                    width: 22%;
                `,
                ])}
        `,
    },
    routingNumberColumn: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                    width: 20%;             
                `,
                    css`
                    width: 22%;
                `,
                    css`
                    width: 22%;                
                `,
                ])}
        `,
    },
    accountNumberColumn: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`                
                    width: 25%;
                `,
                    css`
                    width: 16%;
                `,
                    css`
                    width: 16%;
                `,
                ])}
        `,
    },
    bankAccountContainerForMobile: {
        css: css`
            display: flex;
            flex-direction: row;
            padding: 10px;
            &:nth-child(even) {
                background-color: ${ADIColors.white}!important;
            }
            &:nth-child(odd) {
                background-color: ${ADIColors.white2};
            }
        `
    },
    selectColumnForMobile: {
        css: css`
            padding: 12px 10px 0 10px;
        `
    },
    bankAccountDataContainerForMobile: {
        css: css`
            display: flex;
            padding: 10px 0;
            flex-direction: column;
            text-transform: capitalize;
        `
    },
    // New Styles ----P21 Change
    newListContainer: {
        css: css`
        max-width: 50rem !important;
        margin-top: 10px;
            > ${GridOffset} {
                > ${GridItemStyle} {
                    display: flex;
                    flex-direction: column;
                    padding-top: 0px;
                    padding-bottom: 0px;
                    margin-bottom: 1rem;
                    > ${TypographyStyle} {
                        margin-bottom: 2px;
                    }
                }
            }
        `,
    },
    successMessage: {
        css: css`
        display: inline-flex;
        width: 100%;
        height: 54px;
        margin: 10px 12px 16px 0px;
        font-size: 14px;
        font-weight: 800;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.29;
        letter-spacing: normal;
        color: ${ADIColors.black};
        `
    },
    okButton: {
        css: css`
            border-radius: 4px;
            width:  100%;
            margin-bottom: 15px;
        `
    },
};
const SuccessMessage = styled.div`
    padding: 2px;
    display: flex;
    margin: 5px 0 7px;
    gap: 15px;
    margin-bottom: 15px;
    margin-top: 15px;
    align-items: center;
`;
const styles = tableStyles;

export const BankAccountListInvoiceRecap = (props: any) => {
    const [isMobile, setIsMobile] = React.useState<boolean>(false);
    const { bankAccountList, isLoading, handleRadioChange, selectedBankId, showAddNewAccount, openAddNewAccount, cartState: { value }, invoicePaymentRecapData } = props;
    const [openModal, setopenModal] = useState(false);
    const [openAddressModal, setOpenAddressModal] = useState(false);
    const [initiatedByUserName, setInitiatedByUserName] = useState("");
    const [customerBankData, setCustomerBankData] = useState<customerData | undefined>();
    const [isSuccess, setIsSuccess] = useState(false)
    const dispatch: any = useDispatch();
    const closeModal = () => {
        setopenModal(false);
        setOpenAddressModal(false);
    };
    const closeAddressModal = () => {
        setOpenAddressModal(false);
        setopenModal(true);
    };

    useEffect(() => {
        const onWindowResize = () => {
            if (window.innerWidth >= 768) {
                setIsMobile(false);
            } else {
                setIsMobile(true);
            }
        };
        onWindowResize();

        if (typeof window !== "undefined") {
            window.addEventListener("resize", onWindowResize);
        }

        return () => {
            if (typeof window !== "undefined") {
                window.removeEventListener("resize", onWindowResize);
            }
        };
    }, []);

    useEffect(() => {
        if (openAddNewAccount) {
            setopenModal(true);
        }
        setInitiatedByUserName(value?.initiatedByUserName)
    }, [openAddNewAccount]);

    // New Method --- P21 Change
    const handleDoneAddAccount = (result: boolean, customerData: customerData | undefined) => {
        dispatch(adiGetBankAccountList({}))
        if (result && customerData !== undefined) {
            setOpenAddressModal(result);
            setCustomerBankData(customerData);
        } else {
            setIsSuccess(true);
        }
    }

    const currentState = useSelector((state: CustomApplicationState) => state);
    const languageId = currentState.context.session.language?.id;
    const shipto: any = getShipToState(currentState, currentState.context.session.shipToId);
    useEffect(() => {
        dispatch(loadCurrentCountries(currentState));
    }, []);
    return (
        <StyledWrapper>
            {isLoading &&
                <StyledWrapper {...styles.centeringWrapper}>
                    <LoadingSpinner {...styles.spinner}></LoadingSpinner>
                </StyledWrapper>}
            {isMobile ? (
                <Hidden above="sm">
                    {bankAccountList && bankAccountList?.length !== 0 ?
                        (
                            <RadioGroup
                                name="bankAccount"
                                {...styles.radioListGroup}
                                value={selectedBankId}
                                onChangeHandler={handleRadioChange}
                            >
                                {bankAccountList.map((accountLine: BankAccount, index: number) => (
                                    <StyledWrapper key={`${accountLine.routineNumber}_${index}`} {...styles.bankAccountContainerForMobile}>
                                        <StyledWrapper {...styles.selectColumnForMobile}><Radio value={`${accountLine.bankAccountNumber}-${accountLine.routineNumber}`}></Radio></StyledWrapper>
                                        <StyledWrapper {...styles.bankAccountDataContainerForMobile}>
                                            <StyledWrapper>{accountLine.accountType === "C" ? "Checking" : accountLine.accountType === "S" ? "Saving" : null} <Typography as="span">{accountLine.bankAccountNumber}</Typography></StyledWrapper>
                                            <StyledWrapper>{accountLine.accountDescription?.toLowerCase()}</StyledWrapper>
                                            <StyledWrapper>{translate("Routing #: ")}{accountLine.routineNumber}</StyledWrapper>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                ))}
                            </RadioGroup>
                        ) :
                        <>
                            <Typography {...styles.noDataFound}>
                                There are no bank accounts currently on file.
                            </Typography>
                            <Typography {...styles.newAccount}>
                                Please add a new account to get started.
                            </Typography>
                        </>
                    }
                </Hidden>
            ) : (
                <Hidden below="md">
                    <StyledWrapper {...styles.bankAccountHeaderContainer}>
                        <StyledWrapper {...styles.selectColumn}>{translate("Select")}</StyledWrapper>
                        <StyledWrapper {...styles.accountTypeColumn}>{translate("Account Type")}</StyledWrapper>
                        <StyledWrapper {...styles.accountDesColumn}>{translate("Account Description")}</StyledWrapper>
                        <StyledWrapper {...styles.routingNumberColumn}>{translate("Routing Number")}</StyledWrapper>
                        <StyledWrapper {...styles.accountNumberColumn}>{translate("Account Number")}</StyledWrapper>
                    </StyledWrapper>
                    {bankAccountList && bankAccountList?.length !== 0 ? (
                        <RadioGroup
                            name="bankAccount"
                            {...styles.radioListGroup}
                            value={selectedBankId}
                            onChangeHandler={handleRadioChange}
                        >
                            {bankAccountList.map((accountLine: BankAccount, index: number) => (
                                <StyledWrapper key={`${accountLine.routineNumber}_${index}`} {...styles.bankAccountDataContainer}>
                                    <StyledWrapper {...styles.selectColumn}><Radio value={`${accountLine.bankAccountNumber}-${accountLine.routineNumber}`}></Radio></StyledWrapper>
                                    <StyledWrapper {...styles.accountTypeColumn}>{accountLine.accountType === "C" ? "Checking" : accountLine.accountType === "S" ? "Saving" : null}</StyledWrapper>
                                    <StyledWrapper {...styles.accountDesColumn}>{accountLine.accountDescription?.toLowerCase()}</StyledWrapper>
                                    <StyledWrapper {...styles.routingNumberColumn}>{accountLine.routineNumber}</StyledWrapper>
                                    <StyledWrapper {...styles.accountNumberColumn}>{accountLine.bankAccountNumber}</StyledWrapper>
                                </StyledWrapper>
                            ))}
                        </RadioGroup>
                    ) : (
                        <>
                            <Typography {...styles.noDataFound}>
                                There are no bank accounts currently on file.
                            </Typography>
                            <Typography {...styles.newAccount}>
                                Please add a new account to get started.
                            </Typography>
                        </>
                    )}
                </Hidden>
            )}
            <ADINewAccountModalRecap
                openModal={openModal}
                closeModal={closeModal}
                initiatedByUserName={initiatedByUserName}
                isFormError={false}
                isApiError={false}
                doneAddBankAccount={handleDoneAddAccount}
            />
            {/* // New account address Modal -----P21 Change */}
            <ADINewAccountAddressModalRecap
                openModal={openAddressModal}
                closeModal={closeModal}
                initiatedByUserName={initiatedByUserName}
                isFormError={false}
                isApiError={false}
                closeAddressModal={closeAddressModal}
                address={shipto?.value}
                customerData={customerBankData}
            />
        </StyledWrapper>
    );
}